import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity' 
import type { ItemUnitEntity } from './ItemUnitEntity'
import type { DiscountOnItemEntity } from './DiscountOnItemEntity';
import type { ItemApprovalStatus } from '@/backend/market'

export class ItemMiniEntity {
  id?: number
  itemId?: number
  notAvailableUntil?: string | null;
  branch?: BranchMiniEntity
  name?: string | null
  description?: string | null
  imageUrl?: string | null
  branchId?: number
  unitPrice?: number
  maxQuantityPerOrder?: number
  inventoryQuantity?: number
  order?: number
  categoryName?: string | null
  createdAt?: string | null
  isAvailable?: boolean
  hasSelection?: boolean
  disabled?: boolean 
  unit?: ItemUnitEntity;
  discount?: DiscountOnItemEntity;
  approvalStatus?: ItemApprovalStatus
}
